import { WIDGET_API } from "src/constants";
import { SectionTree } from "src/types";
import { FinishOrderAnalytic } from "src/types/widget";

import { getBasketId } from "./data";

const getEventId = () => {
  const characters = "abcdef0123456789";
  let hash = "";

  for (let i = 0; i < 32; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    hash += characters.charAt(randomIndex);
  }

  return hash;
};

const getDeviceType = () => {
  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (screenWidth < 768) {
    return "Mobile";
  } else if (screenWidth >= 768 && screenWidth < 1024) {
    return "Tablet";
  } else {
    return "Desktop";
  }
};

export const sendAnalyticAddToCart = (productId: number): void => {
  if (!window._garderoboWidget) return;
  //Отправка аналитики в garderobo
  const data = {
    event_name: "add_to_cart",
    fetch_field: "yml_id",
    fetch_id: productId,
    version: 7,
    timestamp: Date.now(),
    session_key: localStorage.getItem("_garderoboSessionKey"),
    event_id: getEventId(),
    device_type: getDeviceType(),
    stat_url: "https://stat.modatech.ru/",
    api_key: WIDGET_API,
  };

  const formData = new URLSearchParams();
  for (const key in data) {
    formData.append(key, data[key as keyof typeof data]?.toString() ?? "");
  }

  const success = navigator.sendBeacon(data["stat_url"], formData);

  // Отправка внутренней аналитики
  window._garderoboWidget.then((widget) => {
    widget.addToCart({ product_id: productId });
  });
};

export const sendAnalyticFinishOrder = (
  products: FinishOrderAnalytic[]
): void => {
  if (!window._garderoboWidget) return;
  const productsData: FinishOrderAnalytic[] = [];
  const transaction_id = getEventId();
  for (let i = 0; i < products.length; i++) {
    const data = {
      event_name: "purchase",
      fetch_field: "yml_id",
      fetch_id: products[i].product_id,
      version: 7,
      timestamp: Date.now(),
      session_key: localStorage.getItem("_garderoboSessionKey"),
      event_id: transaction_id,
      device_type: getDeviceType(),
      transaction_id: transaction_id,
      stat_url: "https://stat.modatech.ru/",
      api_key: WIDGET_API,
    };

    productsData.push({
      product_id: products[i].product_id,
      count: products[i].count,
    });

    for (let j = 0; j < products[i].count; j++) {
      const formData = new URLSearchParams();
      for (const key in data) {
        formData.append(key, data[key as keyof typeof data]?.toString() ?? "");
      }

      const success = navigator.sendBeacon(data["stat_url"], formData);
    }
  }
  window._garderoboWidget.then((widget) =>
    widget.registerPurchase({ product_data: productsData })
  );
};

export const initProductGarderobo = (
  productId: number,
  addToCheckout: (
    filteredProductId: number,
    checkoutId: string | null,
    filteredQuantity: number,
    filteredOfferId: string
  ) => void
): void => {
  if (!window._garderoboWidget) return;
  window._garderoboWidget
    .then((widget) => {
      widget.init(WIDGET_API);

      const garderoboBlock = document.getElementById("garderobo");
      if (garderoboBlock) {
        widget.initProduct(garderoboBlock, {
          product_id: productId,
        });
      }

      widget.registerCallback.addToCartEvent(function (sizeId, data) {
        const checkoutId = getBasketId();
        addToCheckout(data.group_id, checkoutId, 1, sizeId);
        sendAnalyticAddToCart(data.group_id);
      });
    })
    .catch(console.error);
};

export const initCategoryGarderobo = (sectionTree?: SectionTree[]): void => {
  if (!window._garderoboWidget) return;
  let categoryIds: number[] | number = [];
  let gender: null | string = null;

  if (sectionTree) {
    if (sectionTree.length === 0) {
      categoryIds = [99, 100, 101, 102];
    }

    if (sectionTree.length === 1) {
      if (sectionTree[0]?.code === "man") {
        categoryIds = [99, 100, 101, 102];
        gender = "male";
      } else if (sectionTree[0]?.code === "woman") {
        categoryIds = [99, 100, 101, 102];
        gender = "female";
      } else if (
        sectionTree[0]?.code === "sale" ||
        sectionTree[0]?.code === "new"
      ) {
        categoryIds = [99, 100, 101, 102];
      } else if (sectionTree[0]?.code === "interior") {
        categoryIds = [163, 109, 107, 105, 106, 108, 114];
      }
    }

    if (sectionTree.length > 1) {
      if (sectionTree[0]?.code === "man") {
        gender = "male";
      } else if (sectionTree[0]?.code === "woman") {
        gender = "female";
      }
      categoryIds = sectionTree[sectionTree.length - 1]?.id;
    }
  }

  window._garderoboWidget
    .then(function (widget) {
      widget.init(WIDGET_API);

      const garderoboBlock = document.getElementById("garderobo");
      if (garderoboBlock) {
        widget.initCategory(garderoboBlock, {
          category_id: categoryIds,
          gender: gender,
        });
      }
    })
    .catch(console.error);
};

export const initMainGarderobo = (): void => {
  if (!window._garderoboWidget) return;
  window._garderoboWidget
    .then(function (widget) {
      widget.init(WIDGET_API);

      const garderoboBlock = document.getElementById("modatech-widgets");
      if (garderoboBlock) {
        widget.initPlatform(garderoboBlock, {
          tag_name: "Главная",
        });
      }
    })
    .catch(console.error);
};

export const initPage404Garderobo = (): void => {
  if (!window._garderoboWidget) return;
  const garderoboBlock = document.getElementById("garderobo");
  if (garderoboBlock) {
    garderoboBlock.classList.add("garderobo-404-page");
  }

  window._garderoboWidget
    .then(function (widget) {
      widget.init(WIDGET_API);

      const garderoboBlock = document.getElementById("garderobo");
      if (garderoboBlock) {
        widget.initCustom(garderoboBlock, {
          code: "404",
        });
      }
    })
    .catch(console.error);
};

export const sendOfferIds = (offerIds: number[]): void => {
  if (!window._garderoboWidget) return;
  window._garderoboWidget
    .then((widget) => {
      console.log(offerIds);
      widget.setCartProducts(offerIds, "", "", "Добавлено");
    })
    .catch(console.error);
};
